import React, {forwardRef, ReactElement, RefForwardingComponent} from "react";

interface TitleItemProps {
    name: string,
    classValue: string,
    id: string,
    onClick: (id: string) => void,
    direction?: number,
    type?: string
}

const ExportTitleItemComponent: React.FC<TitleItemProps> = ({name, classValue, id, onClick, direction, type}) => {
    const arrow = () =>  direction === 1
        ? <span className='arrow'>&darr;</span>
        : <span className='arrow'>&uarr;</span>;

    return (
        <div className={classValue}
             onClick={() => onClick(id)}
        >
            {type === id ? arrow() : null }
            {name}
        </div>
    )
};

interface TitleProps {
    setSorting: (key: string) => void,
    direction: number,
    type: string,
    forwardRef: React.RefObject<HTMLDivElement>
};

const ExportListTitleComponent:React.FC<TitleProps> = ({setSorting, direction, type, forwardRef}) => {

    return (
        <div className='export-status-content__title'
            ref={forwardRef}
        >
            <ExportTitleItemComponent classValue='export-status-content-title__item name' name={'Name'}
                                id={'cam_name'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <ExportTitleItemComponent classValue='export-status-content-title__item created'
                                name={'Created'}
                                id={'creation_time'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <ExportTitleItemComponent classValue='export-status-content-title__item time'
                                name={'Time'}
                                id={'start_time'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <ExportTitleItemComponent classValue='export-status-content-title__item duration'
                                name={'Duration'}
                                id={'duration'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <ExportTitleItemComponent classValue='export-status-content-title__item size'
                                name={'Size'}
                                id={'size'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <ExportTitleItemComponent classValue='export-status-content-title__item status'
                                name={'Status'}
                                id={'status'}
                                onClick={setSorting}
                                direction={direction}
                                type={type}
            />
            <div className='export-status-content-title__item share'>
                Share
            </div>
        </div>
    )
};

export default ExportListTitleComponent